import { TWO_D_TYPE, THREE_D_TYPE } from '../../utilities/constants/Constants';
import actions from '../actionTypes';
import {
  clearCanvas,
  continueAddToCanvas,
  loadCanvasFromProject,
  setViewType,
  updateProjectPlacingsCoords
} from '../fabricCanvasActions';
import {
  hasLeftMultiWallProjects,
  hasRightMultiWallProjects,
  navigateToLefttWall,
  navigateToRightWall
} from './multiWallHandler';

export const canShowLeftNavigatonButton = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  const { viewType } = getState().fabricCanvas;
  return (
    (project.wallIndex > 0 && viewType == TWO_D_TYPE) ||
    dispatch(hasLeftMultiWallProjects())
  );
};

export const canShowRightNavigatonButton = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  const { viewType } = getState().fabricCanvas;
  return (
    (project.wallIndex < project.walls.length - 1 && viewType == TWO_D_TYPE) ||
    dispatch(hasRightMultiWallProjects())
  );
};

export const canShowtemplateSelectionDialogueIn2D = () => (
  dispatch,
  getState
) => {
  const { project } = getState().finalCheck;
  const { viewType } = getState().fabricCanvas;
  return (
    project.walls.length > 1 &&
    (viewType == TWO_D_TYPE || viewType == THREE_D_TYPE)
  );
};

export const canShowtemplateSelectionDialogueIn3D = () => (
  dispatch,
  getState
) => {
  const { project } = getState().finalCheck;
  return (
    project.walls.length > 1 && getState().fabricCanvas.viewType == THREE_D_TYPE
  );
};

export const actionNavigateLeft = () => (dispatch, getState) => {
  if (dispatch(hasLeftMultiWallProjects())) {
    dispatch(navigateToLefttWall());
  } else {
    const { project } = getState().finalCheck;
    dispatch(selectWallWithIndex(project.wallIndex - 1));
  }
};

export const actionNavigateRight = () => (dispatch, getState) => {
  if (dispatch(hasRightMultiWallProjects())) {
    dispatch(navigateToRightWall());
  } else {
    const { project } = getState().finalCheck;
    dispatch(selectWallWithIndex(project.wallIndex + 1));
  }
};

export const selectWallWithIndex = index => (dispatch, getState) => {
  dispatch(updateProjectPlacingsCoords());
  dispatch(setViewType(TWO_D_TYPE));

  const { project } = getState().finalCheck;
  const { selectedProduct } = getState().home;
  project.wallIndex = index;
  project.activeWall = project.walls[index];
  if (selectedProduct.activeProductSize) {
    if (selectedProduct.activeProductSize.templates.length > index) {
      selectedProduct.activeProductSize.activeTemplate =
        selectedProduct.activeProductSize.templates[index];
    }
  }

  dispatch(clearCanvas());
  dispatch(loadCanvasFromProject());
};

export const showOrHideTemplateSelectionDialogue = (
  canShow,
  backupData
) => dispatch => {
  dispatch({
    type: actions.TEMPLATE_SELECTION_DIALOGUE,
    payload: { showTemplateSelectionDialogue: canShow, backupData }
  });
};

export const templateSelectionApplied = index => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  project.wallIndex = index;
  project.activeWall = project.walls[index];
  const {
    placing,
    properties,
    callback
  } = getState().fabricCanvas.dataPriorToTemplateSelection;
  dispatch(continueAddToCanvas(placing, properties, callback));
  dispatch(showOrHideTemplateSelectionDialogue(false));
};
